import { createContext, useContext } from "react";

export type Mode = "search" | "chat";

export interface SearchChatModeContextValue {
  mode: Mode;
  setMode: (mode: Mode) => void;
}

export const SearchChatModeContext = createContext<
  SearchChatModeContextValue | undefined
>(undefined);

/**
 * Hook to access the search/chat mode context
 * This ensures components share the same mode state
 */
export function useSearchChatModeContext() {
  const context = useContext(SearchChatModeContext);
  if (context === undefined) {
    throw new Error(
      "useSearchChatModeContext must be used within a SearchChatModeProvider"
    );
  }
  return context;
}
